export const getLabel = (str: any = "") =>
  // checking whether type is string, because some values are not strings (e.g. number input), so this is causing exception
  typeof str === "string" ? `${str[0]?.toUpperCase()}${str.replace(/_/g, " ").slice(1)}` : str;
